import { useSelector } from "react-redux";
import { getAuthState } from "features/auth/model/authSlice";
import { Navigate } from "react-router-dom";
import { Paths } from "shared/config/paths";

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isLoggedIn } = useSelector(getAuthState);
  const hasToken = !!localStorage.getItem("token");

  if (!(isLoggedIn || hasToken)) {
    return <Navigate to={Paths.login} replace />;
  }
  return <>{children}</>;
};
